import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import moment from "moment";
import "./styles.css";

export const evidenceTypes = {
  photo: "Photo",
  video: "Video",
  audio: "Audio",
  document: "Document",
};

export const initialEvidence = {
  incidentDetailsId: null,
  id: null,
  type: Object.keys(evidenceTypes)[0],
  description: "",
  file: null,
  fileId: null,
};

export const initialForm = {
  insuranceFile: "",
  moveMeeting: "",
  name: "",
  meetingLabel: "",
  scheduler: "",
  approver: "",
  tasks: [],
  scheduleId: "",
  eventId: "",
  date: "",
  comment: "",
  country: "",
  state: "",
  participants: [],
  isTaskRequired: 1,
  refDocumentId: 0,
  previewMeetingName: "",
  // actualDate: "",
  previewMeetingRefernece: "",
  previewMeetingID: [],
  venue: "",
  // ownerId: "",
  refDocumentDescription: "",
  remarks: "",
  siteName: "",
  type: "",
  agenda: "",
  MeetingType: "",
  meetingSummary: "",
  meetingGroupIds: [],
  siteId: "",
  site: "",
  event: {
    templates: [],
  },
  templates: null,
  templatesForm: null,
  completed: false,
};

export const tableFormat = {
  sid: "",
  scheduleId: "",
  site: "",
  type: "",
  date: "",
  eventName: "",
  owner: "",
  id: "",
};

export const getStatus = (eventStatus, date) => {
  if (eventStatus === "Scheduled" && moment(date).diff(moment(new Date()), "days") < 0)
    return "Overdue";

  return eventStatus;
};

export const getStatusClass = (status) => {
  switch (status) {
    case "Completed":
      return "success";
    case "Scheduled":
      return "orange";
    case "In Progress":
      return "in-progress";
    case "Overdue":
      return "notstarted";
    case "Draft":
      return "pending";
    default:
      return "orange";
  }
};

export const getOhseStatusClass = (status) => {
  switch (status) {
    case MEETING_STATUS.draft:
      return "bg-dark text-white rounded text-center";
    case MEETING_STATUS.planned:
      return "bg-primary text-white rounded text-center px-1";
    case MEETING_STATUS.scheduled:
      return "orange text-white rounded text-center px-1";
    case MEETING_STATUS.executed:
      return "green-300 text-white rounded text-center";
    case MEETING_STATUS.inProgress:
      return "orange text-white rounded text-center";
    case MEETING_STATUS.reviewed:
      return "notstarted";
    case MEETING_STATUS.taskOpen:
      return "yellow text-white rounded text-center";
    case MEETING_STATUS.taskInProgress:
      return "orange text-white rounded text-center";
    case MEETING_STATUS.completed:
      return "green-300 text-white rounded text-center";
    case MEETING_STATUS.taskOverDue:
      return "red text-white rounded text-center px-1";
    case MEETING_STATUS.closed:
      return "success";
    default:
      return "notstarted";
  }
};

export const MEETING_STATUS = {
  draft: "draft",
  planned: "planned",
  scheduled: "scheduled",
  executed: "executed",
  inProgress: "inProgress",
  reviewed: "reviewed",
  taskOpen: "taskOpen",
  taskInProgress: "taskInProgress",
  taskOverDue: "taskOverDue",
  taskOverCompleted: "taskOverCompleted",
  closed: "closed",
};

export const MEETING_STATUS_VIEW = {
  draft: "Draft",
  planned: "Planned",
  scheduled: "Scheduled",
  executed: "Executed",
  inProgress: "In-Progress",
  reviewed: "Reviewed",
  taskInProgress: "Task In Progress",
  taskOverDue: "Task OverDue",
  closed: "Closed",
};

export const getTaskStatusClass = (status) => {
  switch (status) {
    case TASK_STATUS_VIEW.open:
      return "yellow text-white rounded text-center";
    case TASK_STATUS_VIEW.completed:
      return "green-300 text-white rounded text-center";
    case TASK_STATUS_VIEW.overDue:
      return "red text-white rounded text-center";
    default:
      return "notstarted";
  }
};

export const TASK_STATUS_VIEW = {
  open: "Open",
  completed: "Completed",
  OverDue: "Over Due",
};

export const TASK_STATUS = {
  open: "open",
  completed: "completed",
};
export const MeetingScheduler = [
  // { name: "Scheduler Roles", key: "SR" },
  { name: "Safety Officer", key: "safetyOfficer" },
  { name: "Mines Manager", key: "minesManager" },
  // { name: "Mines Manager - RO", key: "minesManager" },
  // { name: "HR Manager - RO", key: "hrManager" },
  { name: "HR Manager", key: "hrManager" },
  { name: "HR Head - RO", key: "hrHead" },
  { name: "Head Safety - HO", key: "headSafety" },
];
export const MeetingReviewer = [
  // { name: "Scheduler Roles", key: "SR" },
  // { name: "Safety Officer", key: "safetyOfficer" },
  // { name: "Mines Manager", key: "minesManager" },
  // { name: "HR Manager", key: "hrManager" },
  // { name: "HR Head", key: "hrHead" },
  // { name: "Regional Manager", key: "regionalManager" },
  { name: "Director Operations", key: "directorOperations" },
];

export const MeetingApprover = [
  { name: "Mines Manager", key: "minesManager" },
  { name: "Regional Manager", key: "regionalManager" },
  { name: "Managing Director", key: "managingDirector" },
  { name: "Director Operations", key: "directorOperations" },
];
export const OHSE_ROLE_LIST_VIEW = {
  reporterOfficer: "Reporter Officer",
  safetyOfficer: "Safety Officer",
  minesManager: "Mines Manager",
  regionalOfficer: "Regional Officer",
  regionalManager: "Regional Manager",
  managingDirector: "Managing Director",
  directorOperations: "Director Operations",
  headSafety: "Head Safety",
};

export const REVIEW_LAVEL = {
  ho: "HO",
  ro: "RO",
  mine: "Mine",
};

export const ohseFilterFields = [
  {
    name: "ownerId",
    title: "Scheduler",
    inputType: EFormFieldInputTypes.searchableSelect,
    // options: Object.keys(OHSE_ROLE_LIST_VIEW).map((k) => ({
    //   label: OHSE_ROLE_LIST_VIEW[k],
    //   value: k,
    // })),
  },
  {
    name: "eventId",
    title: "Review Type",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "siteId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "dateRange",
    title: "Date Range",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "meetingLabel",
    title: "Review Level",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(REVIEW_LAVEL).map((k) => ({
      label: REVIEW_LAVEL[k],
      value: k,
    })),
  },
  // {
  //   name: "progress",
  //   title: "Progress",
  //   inputType: EFormFieldInputTypes.text,
  // },
  {
    name: "reviewedBy",
    title: "Reviewer",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "approvedBy",
    title: "Approver",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "eventStatus",
    title: "Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(MEETING_STATUS_VIEW).map((k) => ({
      label: MEETING_STATUS_VIEW[k],
      value: k,
    })),
  },
];

export const ohseTaskFilterFields = [
  {
    name: "scheduleId",
    title: "OHSE Review ID",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "taskOwnerId",
    title: "Task Owner",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "task_status",
    title: "Task Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(TASK_STATUS_VIEW).map((k) => ({
      label: TASK_STATUS_VIEW[k],
      value: TASK_STATUS_VIEW[k],
    })),
  },
  {
    name: "meetingLabel",
    title: "Review Level",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: Object.keys(REVIEW_LAVEL).map((k) => ({
      label: REVIEW_LAVEL[k],
      value: k,
    })),
  },
  {
    name: "eventId",
    title: "Review Type",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "siteId",
    title: "Location",
    inputType: EFormFieldInputTypes.searchableSelect,
  },
  {
    name: "dateRange",
    title: "Date Range",
    inputType: EFormFieldInputTypes.dateRange,
  },
];
